'use strict';

module.exports = WebSocket;



//////////////////
// WEBPACK FOOTER
// ./node_modules/universal-websocket-client/browser.js
// module id = 926
// module chunks = 5